// Main JavaScript entry point
console.log('Theme loaded');

// Mobile menu toggle
document.addEventListener('DOMContentLoaded', function () {
  const btnMenu = document.querySelector('.btn-menu');
  const siteHeader = document.querySelector('.site-header');
  const siteNavigation = document.querySelector('#site-navigation');
  const menuIcon = btnMenu?.querySelector('.material-symbols-outlined');

  if (btnMenu && siteNavigation && menuIcon) {
    btnMenu.addEventListener('click', function () {
      siteNavigation.classList.toggle('max-lg:hidden');

      // Cambia l'icona tra menu e close
      if (siteNavigation.classList.contains('max-lg:hidden')) {
        menuIcon.textContent = 'menu';
        document.body.classList.remove('overflow-hidden');
        siteHeader.classList.remove('opened');
      } else {
        menuIcon.textContent = 'close';
        document.body.classList.add('overflow-hidden');
        siteHeader.classList.add('opened');
      }
    });
  }
});

// News filter & sort functionality
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lista-news-filters').forEach(function (filterBar) {
    // --- Drag-to-scroll ---
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;

    filterBar.addEventListener('mousedown', function (e) {
      isDragging = true;
      startX = e.pageX - filterBar.offsetLeft;
      scrollLeft = filterBar.scrollLeft;
      filterBar.style.cursor = 'grabbing';
      filterBar.style.userSelect = 'none';
    });

    filterBar.addEventListener('mouseleave', function () {
      isDragging = false;
      filterBar.style.cursor = '';
      filterBar.style.userSelect = '';
    });

    filterBar.addEventListener('mouseup', function () {
      isDragging = false;
      filterBar.style.cursor = '';
      filterBar.style.userSelect = '';
    });

    filterBar.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - filterBar.offsetLeft;
      const walk = x - startX;
      filterBar.scrollLeft = scrollLeft - walk;
    });

    // --- Filter & sort ---
    const filterBtns = filterBar.querySelectorAll('.lista-news-filter-btn');
    const sortBtn = filterBar.querySelector('.lista-news-sort-btn');
    const sortLabel = filterBar.querySelector('.lista-news-sort-label');
    const content = filterBar.nextElementSibling; // .lista-news-content

    const postType = filterBar.dataset.postType;
    const taxonomy = filterBar.dataset.taxonomy;
    const postsPerPage = filterBar.dataset.postsPerPage;
    const gridClasses = filterBar.dataset.gridClasses;
    const nonce = filterBar.dataset.nonce;

    let currentTerm = '';
    let currentOrder = 'DESC';
    let currentPage = 1;

    function fetchPosts() {
      const formData = new FormData();
      formData.append('action', 'lista_news_filter');
      formData.append('nonce', nonce);
      formData.append('post_type', postType);
      formData.append('taxonomy', taxonomy);
      formData.append('term', currentTerm);
      formData.append('order', currentOrder);
      formData.append('posts_per_page', postsPerPage);
      formData.append('paged', currentPage);
      formData.append('grid_classes', gridClasses);

      content.style.opacity = '0.4';
      content.style.pointerEvents = 'none';

      fetch(themeData.ajaxUrl, { method: 'POST', body: formData })
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          content.innerHTML = html;
          content.style.opacity = '1';
          content.style.pointerEvents = '';
        })
        .catch(function () {
          content.style.opacity = '1';
          content.style.pointerEvents = '';
        });
    }

    // Category filter buttons
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        currentTerm = btn.dataset.term;
        currentPage = 1;
        fetchPosts();
      });
    });

    // Sort button: toggle ASC / DESC
    if (sortBtn && sortLabel) {
      sortBtn.addEventListener('click', function () {
        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
        sortLabel.textContent =
          currentOrder === 'DESC' ? themeData.labelRecenti : themeData.labelMenoRecenti;
        currentPage = 1;
        fetchPosts();
      });
    }

    // Pagination buttons (event delegation, perché il contenuto è dinamico)
    content.addEventListener('click', function (e) {
      const pageBtn = e.target.closest('.lista-news-page-btn, .lista-news-arrow-btn');
      if (!pageBtn || pageBtn.classList.contains('is-disabled')) return;
      currentPage = parseInt(pageBtn.dataset.page, 10);
      fetchPosts();
    });
  });
});
